import { useEffect, useState } from 'react';
import { Button, ruler, Flex, Icon, SelectionCard, Text, LocalVideo, RemoteVideo, theme, creditCard } from '../../../2022-component-library';
import { useMediaQuery } from '../../../helpers/useMediaQuery';
import { useAppointment } from '../../../context/appointmentContext';
import { CustomDeviceSelection } from '../../../components';
import styled from '@emotion/styled';
import { usePostMessage } from '../../../context/messageContext';

const VideoContainer = styled(Flex)`
  width: 30vw;
  height: 30vw;
  max-width: 155px;
  max-height: 155px;
  box-shadow: ${theme.elevations.elevation4};
  margin: 1rem;
  border-radius: 4px;
`;

const ResponsiveScreenCalibrationSelection = ({ setStep, setCalibrationStep }) => {
  const [manualCalibrationMethod, setManualCalibrationMethod] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const { appointment } = useAppointment();
  const smallScreen = useMediaQuery('(max-width: 700px)');
  const postMessage = usePostMessage();

  useEffect(() => {
    setUserRole(appointment?.currentUser?.role);
  }, [appointment?.currentUser?.role]);

  const handleManualCalibration = () => {
    const methodName = manualCalibrationMethod.charAt(0).toUpperCase() + manualCalibrationMethod.slice(1);

    if (userRole !== 'patient') {
      const messageContent = {
        type: `step${methodName}Calibration`,
      };
      postMessage(messageContent);
      setStep(manualCalibrationMethod);
    } else {
      const messageContent = {
        type: 'cardCalibration',
        content: {
          screen: manualCalibrationMethod,
        },
      };
      postMessage(messageContent);
      setCalibrationStep(manualCalibrationMethod);
    }
  };

  return (
    <Flex column justifyContent='space-between' padding={smallScreen ? '2.5rem 1.25rem' : '2rem'} height='100%'>
      <Flex justifyContent='center'>
        <VideoContainer>
          <RemoteVideo />
        </VideoContainer>
        <VideoContainer>
          <LocalVideo />
        </VideoContainer>
      </Flex>
      <Text textAlign='center' fontSize={smallScreen ? '0.8rem' : '1rem'} marginBottom='1rem'>
        {`Please select ${userRole === 'patient' ? 'your' : 'a'} device from the list below. If ${
          userRole === 'patient' ? 'your' : "the patient's"
        } device is not listed, ${userRole === 'patient' ? 'ask the clinician for' : 'choose one of the following'} options.`}
      </Text>
      <CustomDeviceSelection />
      {userRole && userRole !== 'patient' ? (
        <>
          <Text size='h2' textAlign='center' color={theme.colors.callToAction} marginBottom='1.5rem'>
            {`-- OR --`}
          </Text>
          <Flex centered>
            {!smallScreen && (
              <SelectionCard
                marginRight='1rem'
                selected={manualCalibrationMethod === 'card'}
                onClick={() => setManualCalibrationMethod((currentState) => (currentState === 'card' ? null : 'card'))}
              >
                <Icon icon={creditCard} color='currentColor' marginBottom='2rem' />
                <Text size='h2'>Use Card</Text>
              </SelectionCard>
            )}
            <SelectionCard
              selected={manualCalibrationMethod === 'ruler'}
              onClick={() => setManualCalibrationMethod((currentState) => (currentState === 'ruler' ? null : 'ruler'))}
            >
              <Icon icon={ruler} color='currentColor' marginBottom='2rem' />
              <Text size='h2'>{smallScreen ? 'Input Manually' : 'Use Ruler'}</Text>
            </SelectionCard>
          </Flex>
          <Text
            visibility={manualCalibrationMethod ? 'visible' : 'hidden'}
            textAlign='center'
            margin={smallScreen ? '1rem' : '2rem'}
            fontSize={smallScreen ? '0.8rem' : '1rem'}
          >
            {`On the next screen, you will receive instructions on how to set your screen size manually. Please have a ${
              manualCalibrationMethod === 'card' ? 'bank or ID card' : 'ruler or tape measure'
            } ready.`}
          </Text>
          <Button
            disabled={!manualCalibrationMethod}
            width='100%'
            onClick={() => {
              handleManualCalibration();
            }}
          >
            Next
          </Button>
        </>
      ) : (
        ''
      )}
    </Flex>
  );
};

export default ResponsiveScreenCalibrationSelection;
